import { useReducer } from 'react';
import { connect } from 'react-redux';

import { LocalizedCurrencyValue } from '@mews-distributor/common';
import { rateCompareFactory } from '@mews-distributor/ui';

import { getCurrentDateSelectedEnterpriseLowestPrice } from '../../modules/pricing/views/enterprisesPricing';
import { ApplicationState } from '../../types';
import { inject } from '../common/Price/inject';
import { adjustCurrencyValueByPercentage } from './currencyValue';
import { getCompetitorPriceRelativeAdjustment, getCompetitors, getRateDescription } from './selectors';

const MewsRateCompare = rateCompareFactory({
    // @ts-expect-error $TSFixMeError: Type 'ConnectedComponent<(<O extends {}>({ hasNetPricing, options, ...props }: LocalizedCurrencyValueProps<O>) => Elemen...
    Price: inject(LocalizedCurrencyValue),
});

const BaseRateCompareContainer = ({
    competitors,
    lowestRoomPrice,
    description,
    priceAdjustment,
    competitorsPrice,
    ...other
}: $TSFixMe) => {
    const [opened, toggleOpened] = useReducer((a: boolean) => !a, true);

    return (
        <MewsRateCompare
            competitors={competitors}
            competitorsPrice={competitorsPrice}
            description={description}
            lowestRoomPrice={lowestRoomPrice}
            priceAdjustment={priceAdjustment}
            opened={opened}
            toggleOpened={toggleOpened}
            {...other}
        />
    );
};

export const RateCompareContainer = connect((state: ApplicationState) => {
    const lowestRoomPrice = getCurrentDateSelectedEnterpriseLowestPrice(state, {});
    const priceAdjustment = getCompetitorPriceRelativeAdjustment(state);
    // @ts-expect-error $TSFixMeError: Argument of type 'MultiCurrencyAmount | null' is not assignable to parameter of type 'Record<string, CurrencyValue>'.
    const competitorsPrice = adjustCurrencyValueByPercentage(lowestRoomPrice, priceAdjustment);
    return {
        lowestRoomPrice,
        priceAdjustment,
        competitorsPrice,
        competitors: getCompetitors(state),
        description: getRateDescription(state),
    };
})(BaseRateCompareContainer);
